import React from 'react';
import './Developer.css';
export default function Developer() {


    return (
        <p className='Developer'>
           Todos los Derechos Reservados ©{new Date().getFullYear()}  Universidad Autónoma de Queretaro
        </p>
    );
}
